export const DRAG_CREATING_TOOL_NAME = 'DragCreatingTool';
